import { yupResolver } from '@hookform/resolvers/yup';
import { InputAdornment } from '@mui/material';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { gridSizeMdLg6, newIvaSchema, ROUTER_PATHS } from '@/shared';
import {
  CreateIvaParams,
  useCreateIva,
  useUpdateIva,
} from '@/shared/actions/erp';
import {
  CustomNumberTextField,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from '@/shared/components/ui';
import { IVA } from '@/shared/interfaces';

export interface SaveIVAInterface {
  titlePage: string;
  editIVA?: IVA;
}

type SaveFormData = CreateIvaParams;

const SaveIVA: React.FC<SaveIVAInterface> = ({ titlePage, editIVA }) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createIVAMutation = useCreateIva({
    navigate,
    returnUrl: ROUTER_PATHS.administration.ivaNav,
  });
  const updateIVAMutation = useUpdateIva(navigate, ROUTER_PATHS.administration.ivaNav);

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newIvaSchema as any),
    defaultValues: {
      estado: true,
    },
  });
  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editIVA?.id_iva) {
      return updateIVAMutation.mutate({
        id: editIVA.id_iva,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createIVAMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editIVA) {
      setShrink(true);
      reset({
        ...editIVA,
      });
    }
  }, [editIVA]);

  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(ROUTER_PATHS.administration.ivaNav);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre || ''}
        error={errors.nombre}
        helperText={errors.nombre?.message ?? ''}
        size={gridSizeMdLg6}
      />
      {/* <CustomTextField
        label="Código"
        name="codigo"
        control={form.control}
        defaultValue={form.getValues().codigo || ''}
        error={errors.codigo}
        helperText={errors.codigo?.message ?? ''}
        size={gridSizeMdLg6}
        disabled={!!editIVA?.codigo}
      /> */}
      {/* <CustomTextField
        label="Número de Referencia"
        name="numero_referencia"
        control={form.control}
        defaultValue={form.getValues().numero_referencia || ''}
        error={errors.numero_referencia}
        helperText={errors.numero_referencia?.message ?? ''}
        size={gridSizeMdLg6}
        required={false}
      /> */}

      <CustomNumberTextField
        label="Porcentaje"
        name="porcentaje"
        control={form.control}
        defaultValue={form.getValues().porcentaje || ''}
        error={errors.porcentaje}
        helperText={errors.porcentaje?.message ?? ''}
        shrink={shrink}
        min={0}
        max={100}
        size={gridSizeMdLg6}
        startAdornment={<InputAdornment position="start">%</InputAdornment>}
      />

      <CustomTextField
        label="SRI Código"
        name="sri_codigo"
        control={form.control}
        defaultValue={form.getValues().sri_codigo || ''}
        error={errors.sri_codigo}
        helperText={errors.sri_codigo?.message ?? ''}
        size={gridSizeMdLg6}
      />
      <CustomTextField
        label="SRI Código Porcentaje"
        name="sri_codigo_porcentaje"
        control={form.control}
        defaultValue={form.getValues().sri_codigo_porcentaje || ''}
        error={errors.sri_codigo_porcentaje}
        helperText={errors.sri_codigo_porcentaje?.message ?? ''}
        shrink={shrink}
        size={gridSizeMdLg6}
      />

      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveIVA;
